import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { RiKey2Line } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import styles from './common.module.scss';

import actions from '@/actions';
import ConfirmSlider from '@/components/ui/ConfirmSlider';
import useAuthorizeCommand from '@/hooks/command/dji/useAuthorizeCommand';
// import { NotifierService as notifier } from '@/libs/Notifier';
import { executeDJICommand } from '@/utils/CommandUtils';

const cx = classNames.bind(styles);

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const [isProcessing, setProcessing] = useState(false);
  const authorizeCommand = useAuthorizeCommand();

  //#region Process Functions
  const process = async (robot) => {
    try {
      await executeDJICommand(robot, authorizeCommand.request());

      onSuccess(robot);
    } catch (error) {
      if (typeof error === 'object' && error?.data?.message) {
        console.debug(error.data.message);
      }
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  // 성공 시 처리
  const onSuccess = (robot) => {
    // TODO: 명령 수행 결과 안내
    // notifier.success(``);
    setProcessing(false);
  };

  // 실패 시 처리
  const onFailure = (robot) => {
    // TODO: 명령 수행 결과 안내
    // notifier.error(``);
    setProcessing(false);
  };
  //#endregion

  useUpdateEffect(() => {
    if (!isProcessing) {
      dispatch(actions.command.resetActivePanels());
      return;
    }

    process(robots[0]);
  }, [isProcessing]);

  const doCommand = () => {
    // 처리 중 상태로 변경
    setProcessing(true);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('desc')}>Request remote controller to authorize the cloud control</div>
      <ConfirmSlider
        width="100%"
        height={40}
        onConfirm={doCommand}
        isProcessing={isProcessing}
        labelStyle={{ fontSize: 12 }}
      />
    </div>
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Request';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiKey2Line;
Command.Panel = Panel;

export default Command;
